import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const workItemRoute: InvariantJiraRoute = {
	name: 'work-item',
	exact: true,
	path: '/browse/work-item/:issueKey(\\w+-\\d+)(.*)?',
};
